import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=155c3067&scoped=true&"
import script from "./ProductList.ts?vue&type=script&lang=ts&"
export * from "./ProductList.ts?vue&type=script&lang=ts&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=155c3067&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c3067",
  null
  
)

export default component.exports